import { render, staticRenderFns } from "./Callback.template.vue?vue&type=template&id=4ca7d1a0&scoped=true&"
var script = {}
import style0 from "./Callback.template.vue?vue&type=style&index=0&id=4ca7d1a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7d1a0",
  null
  
)

export default component.exports